const LISTING_DATE_KEYS = [
  'listing_date',
  'registration_date',
  'registered_at',
  'created_at',
] as const;

/** ISO date string for when the asset was listed (best available field). */
export function assetListingDateIso(data: Record<string, unknown>): string | null {
  for (const key of LISTING_DATE_KEYS) {
    const raw = data[key];
    if (typeof raw === 'string' && raw.trim()) {
      return raw.trim();
    }
  }
  return null;
}

export function formatAssetListingDate(iso: string | null): string | null {
  if (!iso) {
    return null;
  }
  const dt = new Date(iso);
  if (Number.isNaN(dt.getTime())) {
    return null;
  }
  return new Intl.DateTimeFormat(undefined, { dateStyle: 'long' }).format(dt);
}

export function assetListingEmail(data: Record<string, unknown>): string | null {
  const raw = data.email;
  if (typeof raw === 'string' && raw.trim()) {
    return raw.trim();
  }
  return null;
}

export function assetListingPhone(data: Record<string, unknown>): string | null {
  const raw = data.phone_number ?? data.phone ?? data.mobile;
  if (typeof raw === 'string' && raw.trim()) {
    return raw.trim();
  }
  return null;
}
